import { createAsyncThunk } from '@reduxjs/toolkit';
import { logger } from 'common/services';
import { tagServiceApi } from 'tags/tagServiceApi';

import { EventWizardFormSerializedValues } from '../../validation';

export const updateTagCategories = createAsyncThunk<
  void,
  { eventIds: number[]; values: EventWizardFormSerializedValues }
>('[Event Wizard] Update Tag Categories', async ({ eventIds, values }, { dispatch }) => {
  const tagCategories = values.tagCategories ?? [];
  const categories = tagCategories.map(({ name, tags }) => ({ name, tags, isSingleSelection: true }));

  await Promise.all(
    eventIds.map(async (eventId) => {
      try {
        await dispatch(tagServiceApi.endpoints.setEventTagCategories.initiate({ eventId, categories })).unwrap();
      } catch (error) {
        logger.error('Failed to save tag categories for event', { eventId, error });
      }
    })
  );
});
